import Nav from './Nav';
import Footer from './Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { GooglePlayButton, AppStoreButton } from './StoreButtons';

function Home() {
  const screenshots = [
    {
      src: "/1.png",
      alt: "nibblet share info"
    },
    {
      src: "/2.png",
      alt: "nibblet app home screen"
    },
    {
      src: "/3.png",
      alt: "nibblet app recipe details screen"
    },
    {
      src: "/4.png",
      alt: "nibblet app cooking mode screen"
    }
  ];

  return (
    <>
      <Nav />

      <main className="main-content">
        <section className="hero">
          <h1 className="hero-title">Save your recipes in one place & follow them with <em><strong>ease</strong></em>.</h1>
          <div className="download-section">
            <AppStoreButton />
            <GooglePlayButton />
          </div>

          {/* Desktop: Show all screenshots side by side */}
          <div className="app-showcase app-showcase-desktop">
            {screenshots.map((screenshot, index) => (
              <img
                key={index}
                src={screenshot.src}
                alt={screenshot.alt}
                className="app-screenshot"
              />
            ))}
          </div>

          {/* Mobile: Show carousel */}
          <div className="app-showcase app-showcase-mobile">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              pagination={{
                clickable: true,
                el: '.custom-pagination'
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              loop={true}
              className="app-swiper"
            >
              {screenshots.map((screenshot, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={screenshot.src}
                    alt={screenshot.alt}
                    className="swiper-screenshot"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="custom-pagination"></div>
          </div>
        </section >
      </main >

      <Footer />
    </>
  );
}

export default Home;